<section class="hero website-container">
  <div class="hero-brand-info">
    <h1 class="hero-title">
      <span
        class="animated-appear"
        [ngStyle]="{'font-size': titleFontSize()}"
        [innerHTML]="'WEBSITE.HERO.TITLE' | translate | safe: 'html'"
      ></span>
      <svg class="hero-heading-arrow" xmlns="http://www.w3.org/2000/svg" width="102" height="103" viewBox="0 0 102 103" fill="none">
        <path d="M101.15 51.5C101.15 79.1971 78.6971 101.65 51 101.65C23.3029 101.65 0.85 79.1971 0.85 51.5C0.85 23.8029 23.3029 1.35 51 1.35C78.6971 1.35 101.15 23.8029 101.15 51.5Z" fill="#F9F7F5" stroke="#252525" stroke-width="1.7"/>
        <path d="M52.2356 31.1706L56.3766 27.1368L80.5602 51.175L56.3766 75.2132L52.2356 71.1794L69.4623 54.0563L22.0889 54.0563L22.0889 48.2937L69.4623 48.2937L52.2356 31.1706Z" fill="#252525"/>
      </svg>
    </h1>
    <div class="hero-description">
      <p class="hero-description-text page-description">
        {{'WEBSITE.HERO.DESCRIPTION' | translate}}
      </p>

      <div class="hero-buttons">
        <app-button
          class="book-a-demo-btn"
          [routerLink]="['/price']"
          [config]="{
            view: 'primary',
            icon: { name: 'specialArrowRight', position: 'suffix' },
            label: 'COMMON.PRICE',
        }"></app-button>
      </div>
    </div>
  </div>
  <figure class="hero-brand-image-container">
    <img src="https://nuu-static.s3.eu-west-1.amazonaws.com/website/hero_brand.svg" class="hero-brand-image" alt="Brand image"/>
  </figure>
</section>
